import { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import appNavItemTypeCheckers from '../../../../types/appNavItemTypeCheckers';
import { V3AppsContext } from '../../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/V3AppsProvider';

const useMappedEntityAppParams = () => {
  const { allProductApps } = useContext(V3AppsContext);
  const { appSlug, mappedEntityNavItemKey } = useParams();

  const app = useMemo(() => {
    return allProductApps.find((a) => a.urlSlug === appSlug);
  }, [appSlug, allProductApps]);

  const navItem = useMemo(() => {
    if (!app) {
      return undefined;
    }

    for (const s of app.navigationSettings.sections) {
      for (const i of s.items) {
        if (
          i.key === mappedEntityNavItemKey &&
          appNavItemTypeCheckers.isMappedEntityView(i)
        ) {
          return i;
        }
      }
    }
  }, [mappedEntityNavItemKey, app]);

  return {
    app,
    navItem,
  };
};

export default useMappedEntityAppParams;
